module.exports = __webpack_public_path__ + "static/media/new-note.a9f3b113.svg";